module.exports = __webpack_public_path__ + "static/img/navbar_7.6b0ea91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/navbar_7.png
// module id = kXES
// module chunks = 25